import React, { useState, useMemo } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import "./FileClassification.scss";
import { useSelector } from "react-redux";
import { CLASSIFICATION_COLORS } from "../DataTagConstants";
import { percentageCalculation } from "../../../components/common/utilities";

export default function FileClassification({ data = [] }) {
  const totalValue = useSelector((state) => state.dataTagReducer.totalFiles);
  const [excludeNoSensitivity, setExcludeNoSensitivity] = useState(false);

  const filteredData = useMemo(() => {
    if (excludeNoSensitivity) {
      return data.filter((item) => item.type !== "NOT_PROCESSED");
    }
    return data;
  }, [data, excludeNoSensitivity]);

  const chartData = useMemo(() => {
    return filteredData
      .map((item) => {
        const percentageObj = percentageCalculation(
          [{ count: item.count }],
          totalValue
        );
        const percentage = percentageObj[0]?.unRoundPercentage || 0;

        return {
          id: item.type,
          value: item.count > 0 ? item.count : 0.1,
          label: `${item.type.charAt(0).toUpperCase()}${item.type
            .slice(1)
            .toLowerCase()
            .replace(/_/g, " ")} (${percentage}%)`,
          color: CLASSIFICATION_COLORS[item.type] || "#999999",
          percentage,
          count: item.count,
        };
      })
      .sort((a, b) => b.percentage - a.percentage);
  }, [filteredData, totalValue]);

  return (
    <div className="file-classification">
      <div className="chart-header">
        <h4 className="chart-title-data-tag">Classification Type</h4>
        <FormControlLabel
          control={
            <Switch
              checked={excludeNoSensitivity}
              onChange={(e) => setExcludeNoSensitivity(e.target.checked)}
              size="small"
              color="primary"
            />
          }
          className="toggle-label"
        />
      </div>

      <div className="chart-wrapper">
        <div className="chart-container-data-tag">
          <div className="chart-scale-box">
            <PieChart
              series={[
                {
                  data: chartData,
                  innerRadius: 35,
                  outerRadius: 65,
                  cx: 70,
                  cy: 75,
                },
              ]}
              colors={chartData.map((d) => d.color)}
              slotProps={{ legend: { hidden: true } }}
            />
          </div>
        </div>

        <div className="custom-legend">
          {chartData.map((item) => (
            <div key={item.id} className="custom-tooltip-file-classification">
              <div
                style={{
                  width: 12,
                  height: 12,
                  backgroundColor: item.color,
                  marginRight: 8,
                  borderRadius: 2,
                }}
              />
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
